<template>
  <div>
    <div class="EnterTianyi">
      <div class="Enter_box">
        <div class="prev_img">
          <img
            class="img_cover"
            :src="prev_img"
            alt=""
            v-if="trueIndex > 0"
            @mouseenter="prevEnter"
            @mouseleave="prevLeave"
          />
        </div>
        <div class="swiper_box">
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="swiper-container"
          >
            <swiper-slide v-for="(item, index) in slideArr" :key="index">
              <div class="item_slide">
                <div class="slide_top_box">
                  <div class="img_box">
                    <img class="img_cover" :src="item.image" alt="" />
                  </div>
                  <div class="text_box">
                    <div class="big_title">
                      <div class="big_zh">{{ item.name }}</div>
                      <div class="big_en">BRAND INTRODCTION</div>
                    </div>
                    <div class="min_title">{{ item.title }}</div>
                    <div class="info_box">
                      <div class="info">{{ item.intro }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            
          </swiper>
        </div>
        <div class="next_img">
          <img
            class="img_cover"
            :src="next_img"
            alt=""
            v-if="trueIndex < slideArr.length-1"
            @mouseenter="nextEnter"
            @mouseleave="nextLeave"
          />
        </div>
      </div>
        <div class="conto_componets">
            <div class="conto_item" v-for="(item, index) in contoArr" :key="index">
                <div class="item_top">
                    <div class="item_title">{{ item.title }}</div>
                    <div class="item_icon">
                        <img class="img_cover" :src="item.img" alt="" />
                    </div>
                </div>
                <div class="item_bottom">
                    <countTo
                      class="item_num"
                      :startVal="0"
                      :endVal="item.num"
                      :duration="5000"
                      :separator="null"
                    ></countTo>
                    <span class="item_text">{{ item.text }}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getCompany } from "../../http/api";
import countTo from "vue-count-to";
export default {
  name: "",
  props: {},
  components: {
    countTo,
  },
  data() {
    var that = this;
    return {
      prev_img: require("../../assets/indexImg/transparent_prev_img.png"),
      next_img: require("../../assets/indexImg/transparent_next_img.png"),
      trueIndex: 0,
      swiperOption: {
        slidesPerView: 1,
        navigation: {
          nextEl: ".next_img",
          prevEl: ".prev_img",
        },
        // // loop: true,
        on: {
          slideChangeTransitionStart: function () {
            that.trueIndex = this.realIndex;
          },
        },
      },
      contoArr: [
        {
          img: require("../../assets/indexImg/about_enter_icon1.png"),
          title: "产业园区",
          num: 1000,
          text: "亩",
        },
        {
          img: require("../../assets/indexImg/about_enter_icon2.png"),
          title: "总投资",
          num: 32,
          text: "亿",
        },
        {
          img: require("../../assets/indexImg/about_enter_icon3.png"),
          title: "专利技术",
          num: 139,
          text: "项",
        },
        {
          img: require("../../assets/indexImg/about_enter_icon4.png"),
          title: "中国企业",
          num: 500,
          text: "强",
        },
        // {
        //   img: require("../../assets/indexImg/about_enter_icon5.png"),
        //   title: "年销售",
        //   num: 217,
        //   text: "亿",
        // },
      ],
      slideArr: [],
    };
  },
  methods: {
    prevLeave() {
      this.prev_img = require("../../assets/indexImg/transparent_prev_img.png");
    },
    prevEnter() {
      this.prev_img = require("../../assets/indexImg/blue_prev_img.png");
    },
    nextLeave() {
      this.next_img = require("../../assets/indexImg/transparent_next_img.png");
    },
    nextEnter() {
      this.next_img = require("../../assets/indexImg/blue_next_img.png");
    },
    getDatCompany() {
      getCompany().then((res) => {
        this.slideArr = res.data;
        // console.log(res.data)
      });
    },
  },
  mounted() {
    this.getDatCompany();
  },
};
</script>

<style scoped lang='scss'>
.EnterTianyi {
  width: 100%;
  .Enter_box {
    // width: 1684px;
    width: 87.7vw;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-top: 160px;
    margin-top: 16vh;
    .prev_img {
      width: 92px;
      height: 92px;
    }
    .swiper_box {
      width: 1200px;
      @media only screen and (min-width: 1900px) {
      width: 1500px;
    }
      .item_slide {
        // height: 368px;
        height: 36.8vh;
        width: 100%;
        .slide_top_box {
          width: 100%;
          // height: 369px;
          height: 36.9vh;
          display: flex;
          justify-content: space-between;
          .img_box {
            width: 560px;
               @media only screen and (min-width: 1900px) {
      width: 700px;
    }
            height: 100%;
            background: #ffffff;
          }
          .text_box {
            width: 560px;
                      @media only screen and (min-width: 1900px) {
      width: 700px;
    }
            height: 100%;
            overflow-y: hidden;
            .big_title {
              width: 100%;
              display: flex;
              .big_zh {
                font-size: 46px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                // line-height: 61px;
                line-height: 6.1vh;
                color: #ffffff;
              }
              .big_en {
                width: 108px;
                font-size: 22px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                // line-height: 34px;
                line-height: 3.4vh;
                color: #ffffff;
                margin-left: 20px;
              }
            }
            .min_title {
              font-size: 22px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              // line-height: 29px;
              line-height: 2.9vh;
              color: #ffffff;
              // margin: 41px 0 20px 0;
              margin: 4.1vh 0 2vh 0;
            }
            .info_box {
              // height: 181px;
            height: 21vh;
              overflow-y: auto;
              .info {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                // line-height: 28px;
                /* line-height: 2.6vh; */
                line-height: 26px;
                color: #ffffff;
              }
            }
            .info_box::-webkit-scrollbar {
              display: none;
              -ms-overflow-style:none 
            }
       
          }
        }
      }
    }
    .next_img {
      width: 92px;
      height: 92px;
    }
    .prev_img:focus,
    .next_img:focus {
      outline: none;
    }
  }
  .conto_componets {
    /* width: 1153px; */
    width: 1330px;
    /* width: 90%; */
    // height: 100px;
    /* height: 10vh; */
    margin: 0 auto;
    // margin-top: 82px;
    margin-top: 8.2vh;
    display: flex;
    justify-content: space-around;
    .conto_item {
      width: 240px;
      border-right: 1px solid #c8c8c8;
      height: 100%;
      .item_top {
        height: 34px;
        height: 34;
        display: flex;
        justify-content: space-between;
        .item_title {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          // line-height: 19px;
          line-height: 1.9vh;
          color: #ffffff;
          margin-left: 20px;
        }
        .item_icon {
          width: 34px;
          height: 34px;
          margin-right: 20px;
        }
      }
      .item_bottom {
        width: 100%;
        // height: 61px;
        height: 6.1vh;
        margin-top: 1px;
        .item_num {
          margin-left: 20px;
          font-size: 46px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          // line-height: 61px;
          line-height: 6.1vh;
          color: #0fffff;
        }
        .item_text {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          // line-height: 19px;
          line-height: 1.9vh;
          color: #ffffff;
          margin-left: 10px;
        }
      }
    }
    .conto_item:last-child {
      border-right: none;
    }
  }
}
</style>